import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { StaffService } from '@ascschool/services/user/staff.service';
import { TbColumm } from '@ascschool/interface/table/column';
import { TbOption } from '@ascschool/interface/table/option';
import { DatePipe } from '@angular/common';
import { Field, TypeField } from '@ascschool/interface/form/field';
import { BtnOptionExtend, Nztheme } from '@ascschool/interface/button/btn-option-extend';
import { MailService } from '@ascschool/services/mail/mail.service';
import { PopupTagComponent } from '../pop-up/tag/tag.component';

@Component({
  selector: 'app-tag-list',
  templateUrl: './tag-list.component.html',
  styleUrls: ['./tag-list.component.scss']
})
export class TagListComponent implements OnInit {
  get breadcrumbs(): string[] {
    return ['Hộp thư'];
  }
  isResizdePopup: boolean;
  detailDialogRef: NzModalRef;
  titlePopup: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @Output() loadTag = new EventEmitter();
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    public utilService: UtilsService,
    private service: MailService,
    private staffService: StaffService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  formFeildItems: Field[] = [
    new Field('Tìm kiếm', TypeField.INPUT, 'searchTerm', 'Nhập tìm kiếm', false, null, 6)
  ];
  dataSearch: any;
  // thông tin cột table
  columns: TbColumm[] = [
    {
      columnName: 'Màu sắc',
      width: '100px',
      align: 'left',
      key: 'color',
      sortFn: (a, b) => a.color.localeCompare(b.color),
      priority: 2
    },
    {
      columnName: 'Tên nhãn',
      width: '300px',
      align: 'left',
      key: 'name',
      sortFn: (a, b) => a.name.localeCompare(b.name),
      priority: 1
    },
    {
      columnName: 'Ngày tạo',
      width: '',
      align: 'left',
      key: 'createdDate',
      isPipe: true,
      pipe: DatePipe,
      agrPipe: ['dd/MM/yyyy h:mm a'],
      sortFn: (a, b) => a.createdDate.localeCompare(b.createdDate),
      priority: 2
    }
  ];
  // tùy chọn table
  options: TbOption = {
    nzPageSizeOptions: [50, 100, 200],
    nzPageSize: 50,
    total: 0,
    columns: this.columns,
    numbernzLeft: 1,
    numbernzRight: 1,
    nzPageIndex: 1,
    isIndexCol: true,
    isBtnCol: true,
    isEditBtn: true,
    isDeleteBtn: true,
    isScrollTable: true,
    isCheckBoxCol: false
  };
  pageOptBtn: BtnOptionExtend[] = [
    new BtnOptionExtend(
      'Thêm mới',
      'plus',
      this.openAddTag.bind(this),
      null,
      null,
      Nztheme.OUTLINE,
      'text-green-600'
    )
  ];
  // Text
  headerText = '';
  senderReceiverNameText = '';
  senderReceiverTimeText = '';
  listCheckId: any;
  currentUser: any;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm = '';
  pageIndex = 1;
  pageSize = this.options.nzPageSizeOptions[0];
  listPersonSelected: number[] = [];
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation = 50;
  dataTable: any = [];
  ngOnInit() {
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.options.nzPageSizeOptions[0];
    this.reload();
  }

  reload() {
    this.service.getTagPaging(this.commonFilter).subscribe((response) => {
      this.options.total = response && response.rowCount ? response.rowCount : 0;
      this.dataTable = response.results;
    });
  }
  search(event) {
    this.commonFilter = new CommonFilter();
    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSize;
    Object.keys(event).forEach((key) => {
      this.commonFilter[key] = event[key];
    });
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.options.nzPageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.options.nzPageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateSizeTable();
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.openAddTag(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  checkCaculateSizeTable() {
    setTimeout(() => {
      this.options.height = this.heightfnc();
      this.options.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.checkCaculateSizeTable();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.checkCaculateSizeTable();
  }
  openEditTag(item: any) {
    this.titlePopup = 'Sửa nhãn';
    this.isResizdePopup = false;
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupTagComponent,
      nzStyle: { top: '50px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 600,
      nzComponentParams: {
        value: item
      },
    });
    // const instance = dialogRef.getContentComponent();
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
      }
    });
  }
  openAddTag() {
    this.titlePopup = 'Thêm nhãn';
    this.isResizdePopup = false;
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopupTagComponent,
      nzStyle: { top: '50px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzWidth: 600,
      nzComponentParams: {
        value: null
      },
    });
    // const instance = dialogRef.getContentComponent();
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.reload();
        this.loadTag.emit();
      }
    });
  }
  openDeleteTag(item:any) {
    this.titlePopup = 'Xóa nhãn';
    this.isResizdePopup = false;
    this.detailDialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ConfirmComponent,
      nzComponentParams: {
        description: item.name
      },
      nzStyle: { top: '20px' },
      nzMaskClosable: false
    });
    this.detailDialogRef.afterClose.subscribe((result) => {
      if (result) {
        this.service.deleteTag(item.id).subscribe((res: any) => {
          this.notification(res);
          this.reload();
          this.loadTag.emit();
        });
      }
    });
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }
  deleteMany() {
    this.titlePopup = 'Xóa nhãn';
    this.isResizdePopup = false;
    this.listCheckId.forEach((element) => {
      this.listPersonSelected.push(element);
    });
    if (this.listPersonSelected.length > 0) {
      this.detailDialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: ConfirmComponent,
        nzStyle: { top: '20px' },
        nzMaskClosable: false
      });
      this.detailDialogRef.afterClose.subscribe((result) => {
        if (result) {
          this.staffService.deleteMulti(this.listPersonSelected).subscribe((res: any) => {
            this.notification(res);
            this.reload();
            this.loadTag.emit();
          });
        }
      });
    } else {
      this.msg.warning('Bạn chưa chọn dữ liệu để xóa');
    }
  }
  hanlderCheckedId(event) {
    this.listCheckId = event;
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = 600;
    if(this.isResizdePopup === true){
      width = window.innerWidth;
    }
    this.detailDialogRef.updateConfig({
      nzWidth: width
    });
  }
}
